export default "__VITE_ASSET__dPLLBFYi__"